/**
 * 功能: 个人信息列表显示，个人的数据新增、修改，删除数据，可以关联厂牌数据
 */

<template lang="pug">
  .individuai-content
    el-form(:inline="true" :model="findIndividual" style="max-width: 2000px")
      el-form-item.fl(label="")
        el-input(placeholder="请输入搜索内容" v-model="findIndividual.fullSearch" style="width: 300px" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable)
          el-button(slot="append" icon="el-icon-search" @click="clickSearchButton()")
      el-form-item.fl
      el-button(type="primary" :push="10" @click="clickAdd()" :size="GLOBAL.SIZE_OF_INPUTBOX") 添加
    el-col(:span="20")
    el-table(:data="individualData" stripe style="width: 100%" @sort-change='individualSortChange' v-loading="loading")
      el-table-column(prop="avatar" label="头像"  width="120")
        template.avatar-content(slot-scope="scope")
          el-avatar(v-if="scope.row.avatar===undefined" icon="el-icon-user-solid")
          el-avatar(v-else :src="GLOBAL.OSS+scope.row.avatar" )
      el-table-column(prop="name" label="名称" sortable="custom" width="120")
      el-table-column(prop="gender" label="性别" sortable="custom" width="100")
        template(slot-scope="scope")
          p {{scope.row.gender | changeStatus}}
      el-table-column(prop="team" label="厂牌" sortable="custom" )
        template(slot-scope="scope")
          span(v-if="scope.row.teamIds.length === 0") 暂无厂牌
          span(v-for="team in scope.row.teamIds") {{ team.name + '    ' }}
      el-table-column(prop="description" label="描述" sortable="custom" show-overflow-tooltip)
          template(slot-scope="scope")
            span(v-if="scope.row.description" v-html="scope.row.description")
      el-table-column(label="操作" width= "150")
        template(slot-scope="scope")
          el-button-group
            el-button( title = "修改" icon="el-icon-edit" round type="info" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="updateIndividual(scope.$index,scope.row)" )
            el-button( title = "删除" type="danger" icon="el-icon-delete" round
              :size="GLOBAL.SIZE_OF_INPUTBOX" @click="deleteIndividual(scope.row)")
    el-row(:gutter="10")
      el-col
          el-pagination(
              background
              @current-change="handleCurrentChange"
              :current-page.sync="findIndividual.currentPage"
              layout="total,prev, pager, next, jumper"
              :page-size="findIndividual.pageSize"
              :total="totalPage")
    Dialog(ref="dialog" :userInfo="addIndividual" @saveIndividual="saveIndividual")
</template>

<script>
import Enum from '@/apis/enum'
import Dialog from './components/individualDialog'
import Individual from '@/apis/individual'

export default {
  components: {
    Dialog
  },
  data () {
    return {
      findIndividual: {
        fullSearch: '',
        currentPage: 1,
        pageSize: 15,
        sortwhere: { order: 'descending', prop: 'createdAt' }
      },
      totalPage: 0,
      addIndividual: {
      },
      individualData: [],

      loading: false
    }
  },
  created () {
    this.getIndividual()
  },
  filters: {
    changeStatus: function (val) {
      return Enum.getLabel(val, Enum.INDIVIDUAL_GENDER)
    }
  },
  methods: {
    // 个人列表 排序
    individualSortChange (column) {
      const { order, prop } = column
      this.findIndividual.sortwhere = { order, prop }
      this.getIndividual()
    },
    // 筛选
    clickSearchButton () {
      this.findIndividual.currentPage = 1
      this.getIndividual()
    },
    // 获取个人信息分页
    getIndividual () {
      this.loading = true
      Individual.getIndividualPage(this.findIndividual).then(r => {
        this.totalPage = r.data.count
        this.individualData = r.data.data
        this.loading = false
      })
    },
    // 保存个人信息
    saveIndividual (individual, cb) {
      if (individual._id === '' || individual._id === undefined) {
        delete individual._id
        Individual.addNewIndividual(individual).then(r => {
          this.$message({
            type: 'success',
            message: '已添加'
          })
          this.findIndividual.currentPage = 1
          this.getIndividual()
        })
        cb && cb()
      } else {
        Individual.updateIndividual(individual).then(r => {
          this.$message({
            type: 'success',
            message: '已修改'
          })
          this.getIndividual()
        })
        cb && cb()
      }
    },
    // 获取个人分页
    handleCurrentChange (val) {
      this.findIndividual.currentPage = val
      this.getIndividual()
    },

    // 点击新建 显示dialog组件
    clickAdd () {
      this.addIndividual = {}
      this.$refs.dialog.imageUrl = ''
      this.$refs.dialog.teamTags = []
      this.$refs.dialog.isShowIndividualDialog()
    },
    // 点击修改 显示dialog组件
    updateIndividual (index, row) {
      this.addIndividual = row
      this.$refs.dialog.imageUrl = row.avatar
      this.$refs.dialog.teamTags = row.teamIds
      this.$refs.dialog.isShowIndividualDialog()
    },
    // 删除个人信息
    deleteIndividual (row) {
      const data = {
        id: row._id
      }
      this.$confirm('删除个人后相应团队中的个人也将移除, 是否继续?', '警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Individual.deleteIndividual(data).then(r => {
          if (r) {
            this.$message({
              message: '已删除',
              type: 'success'
            })
            this.getIndividual()
          }
        }).catch(err => {
          this.$message({
            message: '删除失败,' + err.msg,
            type: 'error'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style lang="scss">
.individuai-content .el-avatar > img {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
</style>
